// extracted by mini-css-extract-plugin
export default {"host":"style_host__VpVGY","approvalList":"style_approvalList__DKfVN"};